<template>
	<b-modal size="lg" id="invoice-modal" title="Dati fatture" :no-close-on-backdrop="true" hide-footer>
		<div class=" invoice-table">
			<table class="table table-striped">
				<thead>
					<tr>
						<th>Mese</th>
						<th>Importo</th>
						<th>Tipo</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, i) in rows" :key="i">
						<td>
							<div v-if="row.editing" class="d-flex gap-1">
								<b-form-input v-model="row.edit.month" placeholder="Mese" type="number" />
								<b-form-input v-model="row.edit.year" placeholder="Anno" type="number" />
							</div>
							<span v-else>
								{{ row.monthYear.month }}/ {{ row.monthYear.year }}
							</span>
						</td>
						<td>
							<div v-if="row.editing" class="d-flex">
								<b-form-input v-model="row.edit.amount" placeholder="Importo" type="number" />€
							</div>
							<span v-else>
								{{ row.amount }}€
							</span>
						</td>
						<td>
							<div v-if="row.editing">
								<AmountTypeSelector v-model="row.edit.amountType" />

							</div>
							<span v-else>
								{{ codes[row.amountType] || row.amountType }}
							</span>
						</td>
						<td class="text-right buttons">
							<template v-if="!row.editing && !row.deleting">
								<b-btn title="Modifica" class="mr-2" @click="edit(i)">
									<font-awesome-icon icon="cogs" />
								</b-btn>
								<b-btn title="Elimina" variant="danger" @click="maybeDelete(i)">
									<font-awesome-icon icon="fa-times" />
								</b-btn>
							</template>
							<template v-if="row.editing">
								<b-btn class="mr-1" @click="cancelEditing(i)">Annulla</b-btn>
								<b-btn class="" @click="save(i)">Salva</b-btn>
							</template>
							<template v-if="row.deleting">
								<b-btn class="mb-1" @click="cancelDeleting(i)">Annulla</b-btn>
								<b-btn @click="doDelete(i)">Conferma elimina</b-btn>
							</template>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</b-modal>
</template>
<script>
import { mapState } from "vuex";
import VueMonthlyPicker from 'vue-monthly-picker';
import moment from 'moment'
import AmountTypeSelector from '../AmountTypeSelect'

export default {
	name: "InvoiceModal",
	components: { VueMonthlyPicker, AmountTypeSelector },
	data() {
		return {
			rows: [],
			month: moment().subtract(1, 'months'),
			errorMonth: false,
			amount: null,
			amountType: null,
			billAuditReportId: null
		}
	},
	created() {

	},
	methods: {
		setData(data) {
			this.rows = [...data]
		},
		setBillAuditReportId(id) {
			this.billAuditReportId = id
		},
		edit(index) {
			this.rows = this.rows.map((item, i) => {
				if (i == index) {
					item.edit = {
						...item,
						month: item.monthYear.month,
						year: item.monthYear.year,
					}
					item.editing = true
				}
				return item
			})
		},
		cancelEditing(index) {
			this.rows = this.rows.map((item, i) => {
				if (i == index) {
					item.editing = false
				}
				return item
			})
		},
		cancelDeleting(index) {
			this.rows = this.rows.map((item, i) => {
				if (i == index) {
					item.deleting = false
				}
				return item
			})
		},
		maybeDelete(index) {
			this.rows = this.rows.map((item, i) => {
				if (i == index) {
					item.deleting = true
				}
				return item
			})
		},
		async doDelete(index) {
			try {
				const item = this.rows[index]
				const result = await this.$store.dispatch('billaudit/deleteInvoiceData', item.id)
				if (result.code != 1) {
					throw new Error()
				}
				this.rows = this.rows.filter((e, i) => i != index)
			} catch (e) {
				this.$notify({
					type: "error",
					title: 'Errore',
				});
			}
		},
		async save(index) {
			const item = this.rows[index]
			const changes = await this.$store.dispatch('billaudit/upsertInvoiceData', {
				id: item.id,
				billAuditReportId: item.billAuditReportId,
				amount: item.edit.amount,
				amountType: item.edit.amountType,
				monthYear: {
					month: item.edit.month,
					year: item.edit.year
				}
			})
			this.rows = this.rows.map((item, i) => {
				if (i == index) {
					item = changes
					item.editing = false
				}
				return item
			})
		}		
	},
	computed: {
		...mapState({
			codes: state => state.billaudit.codes,			
		}),
		monthLabels() {
			return this.$store.state.utils.monthsShort
		},
	}
}
</script>
<style scoped>
.invoice-table {
	max-height: 70vh;
	overflow-y: auto;
}

.gap-1 {
	gap: 0.5rem;
}

.buttons {
	width: 200px;
}

.d-flex {
	align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/BillAudit/Modals/InvoiceModal.vue